/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './TagStyles.scss';
import { Text } from '../Text';
import { Button } from '../Button';
/**
 * Tag component for labeling and categorization
 * Based on: https://www.figma.com/design/ZCRzifGUbiPZwWVO6jRD58/Quimby---UI--Web-?node-id=2718-3258
 *
 * @example
 * ```tsx
 * <Tag label="Important" variant="red" onRemove={() => console.log('removed')} />
 * <Tag label="Info" variant="blue" readOnly />
 * ```
 */
export function Tag({ label, variant = 'gray', colorStyle = 'solid', size = 'base', readOnly = false, onRemove, icon, className }) {
    // Compact mode: render as small colored dot
    if (size === 'compact') {
        return (React.createElement("span", { className: classNames('qmb-ui-tag', 'qmb-ui-tag--compact', `qmb-ui-tag--${variant}`, `qmb-ui-tag--${colorStyle}`, className), "aria-label": label }));
    }
    // Base mode: render with text label
    return (React.createElement("span", { className: classNames('qmb-ui-tag', `qmb-ui-tag--${variant}`, `qmb-ui-tag--${colorStyle}`, {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'qmb-ui-tag--readonly': readOnly
        }, className) },
        icon && React.createElement("i", { className: classNames('qmb-ui-tag__icon', icon), "aria-hidden": "true" }),
        React.createElement(Text, { variant: "label", className: "qmb-ui-tag__label" }, label),
        !readOnly && onRemove && (React.createElement(Button, { className: "qmb-ui-tag__remove", "aria-label": `Remove ${label} tag`, onClick: onRemove },
            React.createElement("i", { className: "fa-light fa-xmark" })))));
}
